import logo from './logo.svg';
import './App.css';
import { useState } from 'react';

function App() {
  const [showContact, setShowContact] = useState(false)
  const [showPortal, setShowPortal] = useState(false)
  const [error, setError] = useState(null)

  const onSubmit = () => {
    setError("This device (browser) is not recognized. Due to security reasons, we cannot log you in on this device (browser). Please try logging in using another device (browser) or contact our support team. Thanks!")

  }

  return (
    <>
      <div className="top-nav">
        <div className='inner'>
          <img src={"https://tetrasync-website.s3.us-west-1.amazonaws.com/tetrasync-logo.jpg"} className='logo'/>
          <div className='button-container'>
            <a href="#about-card" className='button'>About</a>
            <div className="button" onClick={() => setShowPortal(true)}>Investor</div>
          </div>
        </div>
      </div>
      <div className='home-card'>
        <div className='inner'>
          <div className='left-box'>
            <h1>Solving Health.</h1>
            <p>TetraSync™ pushes the boundaries of science forward with its innovative cellphone-based cancer screening software.</p>
            <a href="#about-card" className='learn-more-button'>Learn More</a>
          </div>
        </div>
      </div>
      <div className="about-card" id='about-card'>
        <div className='inner'>
          <div className='left-box'>
            <h1>About Us</h1>
            <p>TetraSync™ is a medical device company based in Berkeley, California. We are developing a non-invasive colorectal cancer detection software that could be operated outside of hospitals. Our technology is based on years of research and development and is supported by KOLs from top academic institutions like UC Berkeley and UCSF. We are currently conducting studies to evaluate our technology. Our goal is to achieve the same level of sensitivity and specificity as DNA stool tests for colorectal cancer detection and surpass its accuracy for precancerous polyps detection. 
             Our mission is to make medical screening more accessible and help more people diagnose health problems early. </p>
            <h1>Find Us</h1>
            <p><i>LinkedIn:</i> <a style={{color: '#2b830c'}} href="https://www.linkedin.com/company/tetrasync-inc/" target='_blank'>tetrasync-inc</a></p>
            <p><i>Mailing Address:</i> <br/>228 Park Ave S PMB 32706, <br/>New York, New York 10003, US</p>
          </div>
          <hr/>
          <div style={{display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: 'center', marginBottom: 50, textAlign:'center'}}>
            <img src={"https://tetrasync-website.s3.us-west-1.amazonaws.com/tetrasync-logo.jpg"} className='logo'/>
            <p>Copyright © 2025 TetraSync, Inc. All rights reserved.</p>
          </div>
        </div>
      </div>

      <div className='app-modal' style={{"display": showPortal ? "block":"none", "zIndex": 11}}>
        <div className='app-cancel-button' onClick={() => setShowPortal(false)}>X</div>
        <h1>Investors' Portal Login:</h1>
        <hr/>
        <div className='app-portal-container'>
          <label>Investor UID: </label>
          <input />
          <span className='app-portal-submit-button' onClick={onSubmit}>Go</span>
          {error && <p style={{color: 'red'}}>{error}</p>}
        </div>
      </div>
      </>

  );
}

export default App;
